import { useQuery } from "react-query";
import type { PaywallCoupon } from "@/react/types/PaywallCoupon";
import { paywallCouponApi } from "@circle-react/api/paywallCouponApi";
import {
  type PaywallCouponStatus,
  paywallCouponStatuses,
} from "@circle-react/types/PaywallCoupon";

export const paywallCouponListQueryKey = "paywall-coupons-list";

interface DefaultParams {
  paywallId?: number | null;
  queryParams: Record<string, unknown>;
}

export const defaultParams: DefaultParams = {
  paywallId: null,
  queryParams: {},
};

interface UsePaywallCouponListParams {
  couponStatuses?: PaywallCouponStatus[];
  enabled?: boolean;
  paywallId: number | undefined;
  queryParams?: Record<string, unknown>;
  skipDateValidations?: boolean;
}

interface UsePaywallCouponListReturn {
  paywallCouponsListQuery: ReturnType<typeof useQuery<PaywallCoupon[]>>;
}

export const usePaywallCouponList = ({
  paywallId,
  couponStatuses = Object.values(paywallCouponStatuses),
  skipDateValidations = true,
  queryParams = {},
  enabled: enabledOverride = false,
}: UsePaywallCouponListParams): UsePaywallCouponListReturn => {
  const isEnabled = enabledOverride || Boolean(paywallId);

  const paywallCouponsListQuery = useQuery<PaywallCoupon[]>(
    [
      paywallCouponListQueryKey,
      paywallId,
      {
        couponStatuses,
        skipDateValidations,
      },
    ],
    paywallCouponApi.index({ paywallId, skipDateValidations, couponStatuses }),
    { enabled: isEnabled, ...queryParams },
  );

  return {
    paywallCouponsListQuery,
  };
};
